// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"627":"63dac30c","787":"636fddac"}[chunkId] + ".chunk.js";
};